import Swiper from 'swiper';
import {Navigation, Pagination, Thumbs, Autoplay, Keyboard, Controller, EffectCreative} from 'swiper/modules';
Swiper.use([Navigation, Pagination, Thumbs, Autoplay, Keyboard, Controller, EffectCreative]);
window.Swiper = Swiper;
